import { z } from "zod";

/**
 * ReportContasPagarAnaliticoSchema
 */

export const ReportContasPagarAnaliticoColumnsSchema = z.object({
  nroContasPagar: z.boolean().default(false),
  centroCusto: z.boolean().default(false),
  ordemCompra: z.boolean().default(false),
  fornecedor: z.boolean().default(false),
  bancoPagamento: z.boolean().default(false),
  notaFiscal: z.boolean().default(false),
  nroDocumento: z.boolean().default(false),
  responsavel: z.boolean().default(false),
  status: z.boolean().default(false),
  titulo: z.boolean().default(false),
  subconta: z.boolean().default(false),
  dataPagar: z.boolean().default(false),
  dataPago: z.boolean().default(false),
  valorPagar: z.boolean().default(false),
  valorPago: z.boolean().default(false),
  funcionarioFolha: z.boolean().default(false),
  contaBancaria: z.boolean().default(false),
  observacao: z.boolean().default(false),
  notaFiscalEspecial: z.boolean().default(false),
  bdi: z.boolean().default(false),
  nroMedicao: z.boolean().default(false),
  totalBdi: z.boolean().default(false),
  formaPagamento: z.boolean().default(false),
  informacaoGeral: z.boolean().default(false),
  bdi2: z.boolean().default(false),
  totalBdi2: z.boolean().default(false),
  dataCriacao: z.boolean().default(false),
  dataCompetencia: z.boolean().default(false),
});

export const ReportContasPagarAnaliticoSchema = z.object({
  requiredMimeType: z.string().optional().nullable(),
  centroCusto: z.array(z.number()).nullable().default(null),
  subconta: z.array(z.number()).nullable().default(null),
  titulo: z.string().optional().nullable(),
  fornecedor: z.array(z.number()).nullable().default(null),
  ordemCompra: z.array(z.number()).nullable().default(null),
  dataPagarDe: z.coerce.date().optional().nullable(),
  dataPagarAte: z.coerce.date().optional().nullable(),
  dataPagoDe: z.coerce.date().optional().nullable(),
  dataPagoAte: z.coerce.date().optional().nullable(),
  status: z.array(z.number()).nullable().default(null),
  bancoPagamento: z.array(z.number()).nullable().default(null),
  tipoConta: z.string().optional().nullable(),
  nro: z.string().optional().nullable(),
  notaFiscal: z.string().optional().nullable(),
  responsavel: z.array(z.number()).nullable().default(null),
  funcionarioFolha: z.array(z.number()).nullable().default(null),
  idUsuario: z.number().int().optional().nullable(),
  medicao: z.array(z.number()).nullable().default(null),
  produtosServicos: z.array(z.number()).nullable().default(null),
  formaPagamento: z.array(z.number()).nullable().default(null),
  dataCriacaoDe: z.coerce.date().optional().nullable(),
  dataCriacaoAte: z.coerce.date().optional().nullable(),
  dataCompetenciaDe: z.coerce.date().optional().nullable(),
  dataCompetenciaAte: z.coerce.date().optional().nullable(),
  ordenacao: z.coerce.number().optional().nullable().default(0),
  colunas: ReportContasPagarAnaliticoColumnsSchema,
});

/**
 * ReportContasPagarAnaliticoForm
 */

export type ReportContasPagarAnaliticoForm = z.infer<typeof ReportContasPagarAnaliticoSchema>;

export type ReportContasPagarAnaliticoColumnsForm = z.infer<typeof ReportContasPagarAnaliticoColumnsSchema>;

export const defaultReportContasPagarAnaliticoForm: ReportContasPagarAnaliticoForm = {
  centroCusto: null,
  subconta: null,
  titulo: null,
  fornecedor: null,
  ordemCompra: null,
  dataPagarDe: null,
  dataPagarAte: null,
  dataPagoDe: null,
  dataPagoAte: null,
  bancoPagamento: null,
  status: null,
  tipoConta: null,
  nro: null,
  notaFiscal: null,
  responsavel: null,
  funcionarioFolha: null,
  idUsuario: null,
  medicao: null,
  produtosServicos: null,
  formaPagamento: null,
  dataCriacaoDe: null,
  dataCriacaoAte: null,
  dataCompetenciaDe: null,
  dataCompetenciaAte: null,
  requiredMimeType: null,
  ordenacao: 0,
  colunas: {
    nroContasPagar: true,
    centroCusto: true,
    ordemCompra: true,
    fornecedor: true,
    bancoPagamento: true,
    notaFiscal: true,
    nroDocumento: true,
    responsavel: true,
    status: true,
    titulo: true,
    subconta: true,
    dataPagar: true,
    dataPago: true,
    valorPagar: true,
    valorPago: true,
    funcionarioFolha: true,
    contaBancaria: true,
    observacao: true,
    notaFiscalEspecial: true,
    bdi: true,
    nroMedicao: true,
    totalBdi: true,
    formaPagamento: true,
    informacaoGeral: true,
    bdi2: true,
    totalBdi2: true,
    dataCriacao: true,
    dataCompetencia: true
  },

};
